import React from 'react';
import {
  DATA_SOURCE_GROUP_KEY,
  DATA_SOURCE_OPTIONS,
  ConfigGroupSelection
} from './registryUtils';
import { Box, RadioGroup, FormControlLabel, Radio, Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface ConfigGroupSelectorProps {
  groupSelection: ConfigGroupSelection;
  onGroupSelectionChange: (selection: ConfigGroupSelection) => void;
}

/** Radio choice of batch data source (S3 vs SFTP); only configs tagged with the picked `dataSource` are shown and saved. */
const ConfigGroupSelector: React.FC<ConfigGroupSelectorProps> = ({
  groupSelection,
  onGroupSelectionChange
}) => {
  const selected = groupSelection[DATA_SOURCE_GROUP_KEY] || '';

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <RadioGroup
        row
        value={selected}
        onChange={(e) => onGroupSelectionChange({ ...groupSelection, [DATA_SOURCE_GROUP_KEY]: e.target.value })}
      >
        {DATA_SOURCE_OPTIONS.map(option => (
          <FormControlLabel
            key={option}
            value={option}
            control={<Radio size="small" />}
            label={option.replace(/_/g, ' ')}
            sx={{ mr: 2 }}
          />
        ))}
      </RadioGroup>
      <Tooltip
        title="Selecting a configuration type will show only the relevant configurations for that type. Other configurations in the same group will be hidden and not saved."
        arrow
        placement="left"
      >
        <IconButton size="small" sx={{ p: 0.5 }}>
          <InfoOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ConfigGroupSelector;